import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const CardWrapper = styled.div`
  max-width: 250px;
  width: 100%;
  height: 100%;
  position: relative;

  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.minWidth}px) {
    max-width: 100%;
  }
`;

export const ActionWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const LoadingWrapper = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const WrapperNoSignalPage = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  height: 70vh;
`;

export const WrapperNotFound = styled.div`
  display: grid;
  place-items: center;
  gap: 24px;
  text-align: center;
  padding-top: 48px;
`;

export const WrapperNewRegistry = styled.div`
  padding: 16px 0;
  align-self: center;
`;

export const WrapperDescription = styled.div`
  margin-top: 8px;
  text-align: center;
  margin-bottom: 24px;
`;

export const WrapperContent = styled.div`
  display: grid;
  width: 100%;
  place-items: center;
`;

export const ContainerChangelog = styled.div`
  padding: 20px 10px;
`;

export const ContentChangelog = styled.div`
  display: flex;
  margin-left: 10px;
`;

export const WrapperIcon = styled.div`
  margin-top: 10px;
  min-width: 16px;
`;
